import { render, staticRenderFns } from "./Create-Expense.vue?vue&type=template&id=36ec36e0&"
import script from "./Create-Expense.vue?vue&type=script&lang=js&"
export * from "./Create-Expense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports